module.exports = __webpack_public_path__ + "img/checked-grey.367dd2cd.svg";